import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { LoginSection } from '../../components/mi/account/login'
import { StyleBody } from '../../styles/mi'

export const Login: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <LoginSection></LoginSection>
      <MiFooter />
    </StyleBody>
  )
}
